<template>
  <div class="domain-authenticate-form-validate">
    <v-data-table
      class="domain-authenticate-form-validate-list"
      :headers="headers"
      :items="formatedVal"
      :hide-actions="true"
      :no-data-text="$t('message.generics.message.noResultsFound')"
      :no-results-text="$t('message.generics.message.noResultsFound')"
      disable-initial-sort
    >
      <template slot="items" slot-scope="props">
        <tr
          class="domain-authenticate-form-validate-list-item"
          :class="{
            'domain-authenticate-form-validate-list-item_active':
              !!props.item.status,
          }"
        >
          <td class="domain-authenticate-form-validate-list-item-icon">
            <i :class="`mdi mdi-${getItemIcon(props.item)} pointer`"></i>
            <p>{{ getItemText(props.item) }}</p>
          </td>

          <td>
            {{ props.item.type }}
          </td>

          <td>
            <div class="domain-authenticate-form-validate-list-item-record">
              {{ props.item.host }}
              <app-button
                type="button"
                :label="$t('message.generics.message.copy')"
                flat
                small
                @click="copyVal(props.item.host)"
              />
            </div>
          </td>

          <td>
            <div class="domain-authenticate-form-validate-list-item-record">
              {{ props.item.value }}
              <app-button
                type="button"
                :label="$t('message.generics.message.copy')"
                flat
                small
                @click="copyVal(props.item.value)"
              />
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>

    <app-button
      class="domain-authenticate-form-validate-action"
      :loading="validating"
      :label="$t('message.email.message.verify')"
      outline
      @click="validateRecords"
    />
  </div>
</template>

<script>
import EventBus from "@packages/event-bus";
import AppButton from "@/components/generic/button/Button";

export default {
  components: {
    AppButton,
  },

  data() {
    return {
      headers: [
        {
          text: this.$t("message.generics.message.status"),
          value: "",
          sortable: false,
        },
        {
          text: this.$t("message.email.message.type"),
          value: "",
          sortable: false,
        },
        {
          text: this.$t("message.email.message.host"),
          value: "",
          sortable: false,
        },
        {
          text: this.$t("message.email.message.value"),
          value: "",
          sortable: false,
        },
      ],
      internalDomain: this.domain,
      validating: false,
    };
  },

  props: {
    domain: {
      type: Object,
      required: true,
    },
  },

  created() {},

  computed: {
    formatedVal() {
      return [
        {
          status: this.internalDomain.dns.dkim1.valid,
          type: this.internalDomain.dns.dkim1.type,
          host: this.internalDomain.dns.dkim1.host,
          value: this.internalDomain.dns.dkim1.data,
        },
        {
          status: this.internalDomain.dns.dkim2.valid,
          type: this.internalDomain.dns.dkim2.type,
          host: this.internalDomain.dns.dkim2.host,
          value: this.internalDomain.dns.dkim2.data,
        },
        {
          status: this.internalDomain.dns.mail_cname.valid,
          type: this.internalDomain.dns.mail_cname.type,
          host: this.internalDomain.dns.mail_cname.host,
          value: this.internalDomain.dns.mail_cname.data,
        },
      ];
    },
  },

  watch: {},

  methods: {
    getItemIcon(item) {
      return item.status ? `check-circle` : `minus-circle`;
    },
    getItemText(item) {
      return item.status
        ? this.$t("message.email.message.validated")
        : this.$t("message.email.message.pending");
    },
    async validateRecords() {
      this.validating = true;

      const validationRes = await this.$api.marketing.email.dns.validate({
        domainId: this.domain.id,
      });

      this.internalDomain.dns.dkim1.valid =
        validationRes.validation_results.dkim1.valid;

      this.internalDomain.dns.dkim2.valid =
        validationRes.validation_results.dkim2.valid;

      this.internalDomain.dns.mail_cname.valid =
        validationRes.validation_results.mail_cname.valid;

      this.validating = false;

      this.$emit("validated", validationRes.valid);
    },
    copyVal(val) {
      navigator.clipboard.writeText(val);

      EventBus.$emit("show-message", {
        type: "SUCCESS",
        message: this.$t("message.successMessages.message.valueCopied"),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.domain-authenticate-form-validate {
  .domain-authenticate-form-validate-list {
    margin-bottom: 30px;

    .domain-authenticate-form-validate-list-item {
      td {
        font-size: 15px;
      }

      .domain-authenticate-form-validate-list-item-icon {
        display: flex;
        align-items: center;

        i {
          display: flex;
          align-items: center;
          margin-right: 5px;
        }

        p {
          margin: 0;
        }
      }

      .domain-authenticate-form-validate-list-item-record {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
      }

      &.domain-authenticate-form-validate-list-item_active {
        .domain-authenticate-form-validate-list-item-icon {
          color: green;
        }
      }
    }
  }

  .domain-authenticate-form-validate-action {
    margin: 0 auto;
  }
}
</style>
